import { render, staticRenderFns } from "./Record.vue?vue&type=template&id=a7d51a5e&scoped=true&"
import script from "./Record.vue?vue&type=script&lang=js&"
export * from "./Record.vue?vue&type=script&lang=js&"
import style0 from "./Record.vue?vue&type=style&index=0&id=a7d51a5e&lang=less&scoped=true&"
import style1 from "./Record.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d51a5e",
  null
  
)

export default component.exports